'use strict';

function map(arr, fn) {
  // perf: Not using fixed array len here as it may be sparse.
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr) {
      result.push(fn(arr[i], i));
    }
  }
  return result;
}

module.exports = map;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/map.js
// module id = 51
// module chunks = 0